export namespace AdminVoucherListConstants {
    export const pageCommonConstants = {
        title: '바우처 코드 관리',
    };

    export const paginationHeaderConstants = {
        numbering: 'No.',
        timestamp: '등록일자',
        code: '코드',
        status: '상태',
        type: '타입',
        usedTimestamp: '사용 일시',
        expiredTimestamp: '만료 일시',
        sendTimestamp: '발송 일시',
        description: '설명',
        sms: '',
    };
}
